module.exports = __webpack_public_path__ + "static/media/group.54be004d.jpg";